import { render, staticRenderFns } from "./CommentEditForm.vue?vue&type=template&id=42316eb1&"
import script from "./CommentEditForm.vue?vue&type=script&lang=js&"
export * from "./CommentEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports